import { checkIsAllowForPendingBills } from "helpers/utils";
import {
  ACTION_WORKFLOW_INVOICE_POS,
  ACTION_WORKFLOW_INVOICE_POS_FAIL,
  ACTION_WORKFLOW_INVOICE_POS_SUCCESS,
  ADJUST_INVOICE_POS,
  ADJUST_INVOICE_POS_FAIL,
  ADJUST_INVOICE_POS_SUCCESS,
  ATTACK_FILE_INVOICE_POS_UPLOAD,
  ATTACK_FILE_INVOICE_POS_UPLOAD_FAIL,
  ATTACK_FILE_INVOICE_POS_UPLOAD_RESET,
  ATTACK_FILE_INVOICE_POS_UPLOAD_SUCCESS,
  BK_DATA_NEW_POS,
  CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS,
  CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_FAIL,
  CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_SUCCESS,
  CANCEL_INVOICE_POS,
  CANCEL_INVOICE_POS_FAIL,
  CANCEL_INVOICE_POS_SUCCESS,
  CLONE_ENVOICE_POS,
  CLONE_ENVOICE_POS_FAIL,
  CLONE_ENVOICE_POS_SUCCESS,
  CREATE_INVOICE_POS_ENTERPRISE,
  CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL,
  CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_FAIL,
  CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_SUCCESS,
  CREATE_INVOICE_POS_ENTERPRISE_FAIL,
  CREATE_INVOICE_POS_ENTERPRISE_SUCCESS,
  DELETE_INVOICE_POS,
  DELETE_INVOICE_POS_FAIL,
  DELETE_INVOICE_POS_SUCCESS,
  DOWNLOAD_XML_INVOICE_POS,
  DOWNLOAD_XML_INVOICE_POS_FAIL,
  DOWNLOAD_XML_INVOICE_POS_SUCCESS,
  DOWNLOAD_ZIP_INVOICE_POS,
  DOWNLOAD_ZIP_INVOICE_POS_FAIL,
  DOWNLOAD_ZIP_INVOICE_POS_SUCCESS,
  EXPORT_INVOICE_POS,
  EXPORT_INVOICE_POS_FAIL,
  EXPORT_INVOICE_POS_RESET,
  EXPORT_INVOICE_POS_SUCCESS,
  EXPORT_INVOICE_POS_TICKET,
  EXPORT_INVOICE_POS_TICKET_FAIL,
  EXPORT_INVOICE_POS_TICKET_RESET,
  EXPORT_INVOICE_POS_TICKET_SUCCESS,
  EXPORT_INVOICE_POS_WAREHOUSES,
  EXPORT_INVOICE_POS_WAREHOUSES_AGENCY,
  EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_FAIL,
  EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_RESET,
  EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_SUCCESS,
  EXPORT_INVOICE_POS_WAREHOUSES_FAIL,
  EXPORT_INVOICE_POS_WAREHOUSES_RESET,
  EXPORT_INVOICE_POS_WAREHOUSES_SUCCESS,
  GENERATE_NUMBER_INVOICE_POS,
  GENERATE_NUMBER_INVOICE_POS_FAIL,
  GENERATE_NUMBER_INVOICE_POS_SUCCESS,
  GET_CURRENT_TIME_POS,
  GET_CURRENT_TIME_POS_FAIL,
  GET_CURRENT_TIME_POS_SUCCESS,
  GET_DATA_LINK_POS,
  GET_DATA_LINK_POS_FAIL,
  GET_DATA_LINK_POS_RESET,
  GET_DATA_LINK_POS_SUCCESS,
  GET_ENTERPRISE_POS_BY_TAX_CODE,
  GET_ENTERPRISE_POS_BY_TAX_CODE_FAIL,
  GET_ENTERPRISE_POS_BY_TAX_CODE_RESET,
  GET_ENTERPRISE_POS_BY_TAX_CODE_SUCCESS,
  GET_INVOICE_POS_MAX_DATE,
  GET_INVOICE_POS_MAX_DATE_FAIL,
  GET_INVOICE_POS_MAX_DATE_RESET,
  GET_INVOICE_POS_MAX_DATE_SUCCESS,
  GET_INVOICE_POS_MIN_DATE,
  GET_INVOICE_POS_MIN_DATE_FAIL,
  GET_INVOICE_POS_MIN_DATE_RESET,
  GET_INVOICE_POS_MIN_DATE_SUCCESS,
  GET_INVOICE_POS_REPORT_WORD,
  GET_INVOICE_POS_REPORT_WORD_FAIL,
  GET_INVOICE_POS_REPORT_WORD_SUCCESS,
  INVOICE_POS_CAMPAIGN_DETAIL,
  INVOICE_POS_CAMPAIGN_DETAIL_FAIL,
  INVOICE_POS_CAMPAIGN_DETAIL_RESET,
  INVOICE_POS_CAMPAIGN_DETAIL_SUCCESS,
  INVOICE_POS_CAMPAIGN_LIST,
  INVOICE_POS_CAMPAIGN_LIST_FAIL,
  INVOICE_POS_CAMPAIGN_LIST_RESET,
  INVOICE_POS_CAMPAIGN_LIST_SUCCESS,
  INVOICE_POS_CREATE,
  INVOICE_POS_CREATE_FAIL,
  INVOICE_POS_CREATE_RESET,
  INVOICE_POS_CREATE_SUCCESS,
  INVOICE_POS_DETAIL,
  INVOICE_POS_DETAIL_FAIL,
  INVOICE_POS_DETAIL_RESET,
  INVOICE_POS_DETAIL_SUCCESS,
  INVOICE_POS_EDIT,
  INVOICE_POS_EDIT_FAIL,
  INVOICE_POS_EDIT_RESET,
  INVOICE_POS_EDIT_SUCCESS,
  INVOICE_POS_LIST,
  INVOICE_POS_LIST_COLUMN,
  INVOICE_POS_LIST_FAIL,
  INVOICE_POS_LIST_RESET,
  INVOICE_POS_LIST_SALE_HAVE_CODE_COLUMN,
  INVOICE_POS_LIST_SALE_NONE_CODE_COLUMN,
  INVOICE_POS_LIST_SUCCESS,
  INVOICE_POS_LIST_VAT_NONE_CODE_COLUMN,
  LOAD_CONFIG_INVOICE_POS_FIELD,
  LOAD_CONFIG_INVOICE_POS_FIELD_FAIL,
  LOAD_CONFIG_INVOICE_POS_FIELD_SUCCESS,
  PHASE_INVOICE_POS_DETAIL,
  PHASE_INVOICE_POS_DETAIL_FAIL,
  PHASE_INVOICE_POS_DETAIL_RESET,
  PHASE_INVOICE_POS_DETAIL_SUCCESS,
  PHASE_INVOICE_POS_LIST,
  PHASE_INVOICE_POS_LIST_COLUMN,
  PHASE_INVOICE_POS_LIST_FAIL,
  PHASE_INVOICE_POS_LIST_RESET,
  PHASE_INVOICE_POS_LIST_SUCCESS,
  PREVIEW_PDF_INVOICE_POS,
  PREVIEW_PDF_INVOICE_POS_FAIL,
  PREVIEW_PDF_INVOICE_POS_SUCCESS,
  RELEASE_CAMPAIGNS_INVOICE_POS,
  RELEASE_CAMPAIGNS_INVOICE_POS_FAIL,
  RELEASE_CAMPAIGNS_INVOICE_POS_RESET,
  RELEASE_CAMPAIGNS_INVOICE_POS_SUCCESS,
  RELEASE_INVOICE_POS,
  RELEASE_INVOICE_POS_FAIL,
  RELEASE_INVOICE_POS_SUCCESS,
  REMOVE_FILE_INVOICE_POS,
  REMOVE_FILE_INVOICE_POS_FAIL,
  REMOVE_FILE_INVOICE_POS_RESET,
  REMOVE_FILE_INVOICE_POS_SUCCESS,
  REPLACE_INVOICE_POS,
  REPLACE_INVOICE_POS_FAIL,
  REPLACE_INVOICE_POS_SUCCESS,
  RESET_ACTION_WORKFLOW_INVOICE_POS,
  RESET_ADJUST_INVOICE_POS,
  RESET_BK_DATA_NEW_POS,
  RESET_CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS,
  RESET_CANCEL_INVOICE_POS,
  RESET_CLONE_ENVOICE_POS,
  RESET_CREATE_INVOICE_POS_ENTERPRISE,
  RESET_CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL,
  RESET_DELETE_INVOICE_POS,
  RESET_DOWNLOAD_XML_INVOICE_POS,
  RESET_DOWNLOAD_ZIP_INVOICE_POS,
  RESET_GENERATE_NUMBER_INVOICE_POS,
  RESET_GET_INVOICE_POS_REPORT_WORD,
  RESET_PREVIEW_PDF_INVOICE_POS,
  RESET_RELEASE_INVOICE_POS,
  RESET_REPLACE_INVOICE_POS,
  RESET_SEND_MAIL_INVOICE_POS,
  RESET_TRANSFER_USB_INVOICE_POS,
  SEND_MAIL_INVOICE_POS,
  SEND_MAIL_INVOICE_POS_FAIL,
  SEND_MAIL_INVOICE_POS_SUCCESS,
  SET_COLUMN_VISIBLE_INVOICE_POS_CAMPAIGN_LIST,
  TRANSFER_USB_INVOICE_POS,
  TRANSFER_USB_INVOICE_POS_FAIL,
  TRANSFER_USB_INVOICE_POS_SUCCESS,
  UPLOAD_CAMPAIGNS_INVOICE_POS,
  UPLOAD_CAMPAIGNS_INVOICE_POS_FAIL,
  UPLOAD_CAMPAIGNS_INVOICE_POS_RESET,
  UPLOAD_CAMPAIGNS_INVOICE_POS_SUCCESS,
  UPLOAD_FILE_INVOICE_POS,
  UPLOAD_FILE_INVOICE_POS_FAIL,
  UPLOAD_FILE_INVOICE_POS_RESET,
  UPLOAD_FILE_INVOICE_POS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  // List Issue Invoice
  list: {
    items: [],
    totalCount: 0,
    columnsVisibleInvoice: null,
    columnsVisibleVATNoneCode: null,
    columnsVisibleSaleHaveCode: null,
    columnsVisibleSaleNoneCode: null,
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
  },
  detailInvoicePos: {
    loading: false,
    data: null,
    error: null,
  },
  listPhase: {
    items: [],
    totalCount: 0,
    columnsVisibleInvoice: null,
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
  },
  detailPhase: {
    loading: false,
    data: null,
    error: null,
  },
  enterpriseByTaxCode: {
    loading: false,
    data: null,
    error: null,
  },
  loadingList: false,
  errorList: null,

  loadingListPhase: false,
  errorListPhase: null,

  // Create Issue Invoice
  create: null,
  loadingCreate: false,
  errorCreate: null,
  // Edit Issue Invoice
  edit: null,
  loadingEdit: false,
  errorEdit: null,
  //
  successClone: false,
  configField: {
    error: null,
    loading: false,
    isFinish: false,
    businessUnitInfo: null,
    listCurrency: [],
    listVat: [],
    listPaymentMethod: [],
  },
  //
  releaseInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // Xóa hóa đơn
  deleteInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // Hủy hóa đơn
  cancelInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // callbackTaxRefusedApprovalData
  callbackTaxRefusedApprovalData: {
    loading: false,
    data: null,
    error: null,
  },
  // Download
  fileDownloadResponse: null,
  fileDownload: null,
  fileDownloadName: null,
  // send usb xml sign
  transferUSB: {
    data: null,
    error: null,
    loading: false,
  },
  //invoiceNumber
  invoiceNumber: {
    data: null,
    error: null,
    loading: false,
  },
  // Replace invoice
  replaceInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // Adjust invoice
  adjustInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // Send mail invoice
  sendMailInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  //
  previewPdfFile: {
    data: null,
    loading: false,
    error: null,
  },
  //
  uploadFile: null,
  loadingUploadFile: false,
  errorUploadFile: false,
  // SUBMIT/APPROVE/REJECT
  workflowInvoice: {
    loading: false,
    data: null,
    error: null,
    typeWorkflow: null,
  },
  // Tạo hóa đơn doanh nghiệp từ hóa đơn khách hàng lẻ
  createInvoiceEnterpriseData: {
    loading: false,
    data: null,
    error: null,
  },
  // Tạo hóa đơn điều chỉnh giảm 100%
  createInvoiceEnterpriseAdjustAllData: {
    loading: false,
    data: null,
    error: null,
  },
  // Upload biên bản hóa
  uploadFileInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Xóa biên bản hóa
  removeFileInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Export invoice
  exportInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Export invoice ticket
  exportInvoiceTicketData: {
    loading: false,
    data: null,
    error: null,
  },
  // export Invoice Warehouses Data
  exportInvoiceWarehousesData: {
    loading: false,
    data: null,
    error: null,
  },
  //export Invoice Warehouses Agency Data
  exportInvoiceWarehousesAgencyData: {
    loading: false,
    data: null,
    error: null,
  },
  //downloadZipInvoiceData
  downloadZipInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  //  Danh sách lô hóa đơn
  invoiceCampaignListData: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  // Upload lô hóa đơn
  uploadCampaignsInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Phát hành lô hóa đơn
  releaseCampaignsInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Detail lô hóa đơn
  invoiceCampaignDetailData: {
    loading: false,
    data: null,
    error: null,
  },
  // Thông tin hóa đơn điều chỉnh thay thế child/parent
  linkTypeData: {
    loading: false,
    data: null,
    error: null,
  },
  // Thông tin của ngày lập hóa đơn đã phát hành gần nhất
  invoiceMaxDate: {
    loading: false,
    data: null,
    error: null,
  },
  // Thông tin của ngày lập hóa đơn lưu tạm xa nhất || Thông tin của ngày lập hóa đơn đã phát hành gần nhất
  invoiceMaxMinDate: {
    loading: false,
    data: null,
    error: null,
  },
  // Ngày hiện tại theo giờ hệ thống
  currentTime: {
    loading: false,
    data: null,
    error: null,
  },
};

const invoicePos = (state = INIT_STATE, action) => {
  const curInvoiceCampaignListData = state.invoiceCampaignListData;
  switch (action.type) {
    // List Issue Invoice
    case INVOICE_POS_LIST:
      return {
        ...state,
        loadingList: action.showLoading,
        errorList: null,
      };
    case INVOICE_POS_LIST_SUCCESS:
      return {
        ...state,
        errorList: null,
        loadingList: false,
        list: {
          ...state.list,
          items: action.payload.items?.map(i => {
            return {
              ...i,
              isAllowForPendingBills: checkIsAllowForPendingBills(i),
            };
          }),
          totalCount: action.payload._meta
            ? action.payload._meta.totalCount
            : action.payload.items.length,
        },
      };
    case INVOICE_POS_LIST_FAIL:
      return { ...state, loadingList: false, errorList: action.payload };
    case INVOICE_POS_LIST_RESET:
      return {
        ...state,
        loadingList: false,
        errorList: null,
        list: {
          ...state.list, // columnsVisible
          items: [],
          totalCount: 0,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
        },
      };
    // List PHASE Invoice
    case PHASE_INVOICE_POS_LIST:
      return {
        ...state,
        loadingListPhase: action.showLoading,
        errorListPhase: null,
      };
    case PHASE_INVOICE_POS_LIST_SUCCESS:
      return {
        ...state,
        errorListPhase: null,
        loadingListPhase: false,
        listPhase: {
          ...state.listPhase,
          items: action.payload.items,
          totalCount: action.payload._meta
            ? action.payload._meta.totalCount
            : action.payload.items.length,
        },
      };
    case PHASE_INVOICE_POS_LIST_FAIL:
      return {
        ...state,
        loadingListPhase: false,
        errorListPhase: action.payload,
      };
    case PHASE_INVOICE_POS_LIST_RESET:
      return {
        ...state,
        loadingListPhase: false,
        errorListPhase: null,
        listPhase: {
          ...state.listPhase, // columnsVisible
          items: [],
          totalCount: 0,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
        },
      };
    // Clone envoice
    case CLONE_ENVOICE_POS:
      return {
        ...state,
        loadingList: true,
        errorList: null,
      };
    case CLONE_ENVOICE_POS_SUCCESS:
      return {
        ...state,
        errorList: null,
        loadingList: false,
        successClone: true,
      };
    case CLONE_ENVOICE_POS_FAIL:
      return {
        ...state,
        successClone: false,
        loadingList: false,
        errorList: action.payload,
      };
    case RESET_CLONE_ENVOICE_POS:
      return {
        ...state,
        successClone: false,
        loadingList: false,
        errorList: action.payload,
      };

    // Detail invoice pos
    case INVOICE_POS_DETAIL:
      return {
        ...state,
        detailInvoicePos: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case INVOICE_POS_DETAIL_SUCCESS:
      return {
        ...state,
        detailInvoicePos: {
          loading: false,
          data: {
            ...action.data,
            isAllowForPendingBills: checkIsAllowForPendingBills(action.data),
          },
          error: null,
        },
      };

    case INVOICE_POS_DETAIL_FAIL:
      return {
        ...state,
        detailInvoicePos: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    case INVOICE_POS_DETAIL_RESET:
      return {
        ...state,
        detailInvoicePos: {
          loading: false,
          data: null,
          error: null,
        },
      };
    // Detail Phase
    case PHASE_INVOICE_POS_DETAIL:
      return {
        ...state,
        detailPhase: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case PHASE_INVOICE_POS_DETAIL_SUCCESS:
      return {
        ...state,
        detailPhase: {
          loading: false,
          data: action.data,
          error: null,
        },
      };

    case PHASE_INVOICE_POS_DETAIL_FAIL:
      return {
        ...state,
        detailPhase: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    case PHASE_INVOICE_POS_DETAIL_RESET:
      return {
        ...state,
        detailPhase: {
          loading: false,
          data: null,
          error: null,
        },
      };
    // GET_ENTERPRISE_POS_BY_TAX_CODE
    case GET_ENTERPRISE_POS_BY_TAX_CODE:
      return {
        ...state,
        enterpriseByTaxCode: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_ENTERPRISE_POS_BY_TAX_CODE_SUCCESS:
      return {
        ...state,
        enterpriseByTaxCode: {
          loading: false,
          data: action.data,
          error: null,
        },
      };

    case GET_ENTERPRISE_POS_BY_TAX_CODE_FAIL:
      return {
        ...state,
        enterpriseByTaxCode: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    case GET_ENTERPRISE_POS_BY_TAX_CODE_RESET:
      return {
        ...state,
        enterpriseByTaxCode: {
          loading: false,
          data: null,
          error: null,
        },
      };
    //
    case INVOICE_POS_LIST_COLUMN:
      const currentColumnsVisibleInvoice =
        state.list.columnsVisibleInvoice || {};
      currentColumnsVisibleInvoice[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: {
          ...state.list,
          columnsVisibleInvoice: currentColumnsVisibleInvoice,
        },
      };
    case PHASE_INVOICE_POS_LIST_COLUMN:
      const currentPhaseColumnsVisibleInvoice =
        state.listPhase.columnsVisibleInvoice || {};
      currentPhaseColumnsVisibleInvoice[action.payload.field] =
        action.payload.value;
      return {
        ...state,
        listPhase: {
          ...state.listPhase,
          columnsVisibleInvoice: currentPhaseColumnsVisibleInvoice,
        },
      };
    case INVOICE_POS_LIST_VAT_NONE_CODE_COLUMN:
      const currentColumnsVATNoneCode =
        state.list.columnsVisibleVATNoneCode || {};
      currentColumnsVATNoneCode[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: {
          ...state.list,
          columnsVisibleVATNoneCode: currentColumnsVATNoneCode,
        },
      };
    case INVOICE_POS_LIST_SALE_HAVE_CODE_COLUMN:
      const currentColumnsSaleHaveCode =
        state.list.columnsVisibleSaleHaveCode || {};
      currentColumnsSaleHaveCode[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: {
          ...state.list,
          columnsVisibleSaleHaveCode: currentColumnsSaleHaveCode,
        },
      };
    case INVOICE_POS_LIST_SALE_NONE_CODE_COLUMN:
      const currentColumnsSaleNoneCode =
        state.list.columnsVisibleSaleNoneCode || {};
      currentColumnsSaleNoneCode[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: {
          ...state.list,
          columnsVisibleSaleNoneCode: currentColumnsSaleNoneCode,
        },
      };

    // Create Issue Invoice
    case INVOICE_POS_CREATE:
      return {
        ...state,
        loadingCreate: true,
        errorCreate: null,
      };
    case INVOICE_POS_CREATE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: { ...action.payload, success: true },
        type: action.type,
      };
    case INVOICE_POS_CREATE_FAIL:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: action.payload,
        type: action.type,
      };
    case INVOICE_POS_CREATE_RESET:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: null,
        type: action.type,
      };
    // Edit Issue Invoice
    case INVOICE_POS_EDIT:
      return {
        ...state,
        loadingEdit: true,
        errorEdit: null,
      };
    case INVOICE_POS_EDIT_SUCCESS:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: null,
        edit: { ...action.payload, success: true },
      };
    case INVOICE_POS_EDIT_FAIL:
      return { ...state, loadingEdit: false, errorEdit: action.payload };
    case INVOICE_POS_EDIT_RESET:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: null,
        edit: null,
      };
    //LOAD_CONFIG_INVOICE_POS_FIELD
    case LOAD_CONFIG_INVOICE_POS_FIELD:
      return {
        ...state,
        configField: {
          loading: true,
          isFinish: false,
          error: null,
          businessUnitInfo: null,
          listCurrency: [],
          listVat: [],
          listPaymentMethod: [],
        },
      };
    case LOAD_CONFIG_INVOICE_POS_FIELD_SUCCESS:
      return {
        ...state,
        configField: {
          loading: false,
          isFinish: true,
          error: null,
          businessUnitInfo: action.businessUnitInfo,
          listCurrency: action.listCurrency,
          listVat: action.listVat,
          listPaymentMethod: action.listPaymentMethod,
        },
      };
    case LOAD_CONFIG_INVOICE_POS_FIELD_FAIL:
      return {
        ...state,
        configField: {
          loading: false,
          isFinish: true,
          error: action.error,
          businessUnitInfo: null,
          listCurrency: [],
          listVat: [],
          listPaymentMethod: [],
        },
      };
    // Action Download
    case DOWNLOAD_XML_INVOICE_POS:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
      };
    case DOWNLOAD_XML_INVOICE_POS_SUCCESS:
      return {
        ...state,
        type: action.type,
        fileDownloadResponse: action.fileDownloadResponse,
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
      };
    case DOWNLOAD_XML_INVOICE_POS_FAIL:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
        error: action.error,
      };
    case RESET_DOWNLOAD_XML_INVOICE_POS:
      return {
        ...state,
        type: null,
        error: null,
        // fileDownloadResponse: null,
        // fileDownload: null,
        // fileDownloadName: null,
      };
    // Phát hành hóa đơn
    case RELEASE_INVOICE_POS:
      return {
        ...state,
        releaseInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case RELEASE_INVOICE_POS_SUCCESS:
      return {
        ...state,
        releaseInvoice: {
          loading: false,
          data: null,
          adjustAll: action.adjustAll,
          error: null,
        },
        type: action.type,
      };

    case RELEASE_INVOICE_POS_FAIL:
      return {
        ...state,
        releaseInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_RELEASE_INVOICE_POS:
      return {
        ...state,
        releaseInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Tạo đăng ký sử sụng
    case TRANSFER_USB_INVOICE_POS:
      return {
        ...state,
        transferUSB: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case TRANSFER_USB_INVOICE_POS_SUCCESS:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };

    case TRANSFER_USB_INVOICE_POS_FAIL:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: action.error,
          loading: false,
        },
      };
    case RESET_TRANSFER_USB_INVOICE_POS:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };
    // GENERATE_NUMBER_INVOICE_POS
    case GENERATE_NUMBER_INVOICE_POS:
      return {
        ...state,
        invoiceNumber: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case GENERATE_NUMBER_INVOICE_POS_SUCCESS:
      return {
        ...state,
        type: action.type,
        invoiceNumber: {
          data: action.data,
          error: null,
          loading: false,
        },
      };

    case GENERATE_NUMBER_INVOICE_POS_FAIL:
      return {
        ...state,
        type: action.type,
        invoiceNumber: {
          data: null,
          error: action.error,
          loading: false,
        },
      };
    case RESET_GENERATE_NUMBER_INVOICE_POS:
      return {
        ...state,
        type: action.type,
        invoiceNumber: {
          data: null,
          error: null,
          loading: false,
        },
      };
    // Thay thế hóa đơn
    case REPLACE_INVOICE_POS:
      return {
        ...state,
        replaceInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case REPLACE_INVOICE_POS_SUCCESS:
      return {
        ...state,
        replaceInvoice: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case REPLACE_INVOICE_POS_FAIL:
      return {
        ...state,
        replaceInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_REPLACE_INVOICE_POS:
      return {
        ...state,
        replaceInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Điều chỉnh hóa đơn
    case ADJUST_INVOICE_POS:
      return {
        ...state,
        adjustInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case ADJUST_INVOICE_POS_SUCCESS:
      return {
        ...state,
        adjustInvoice: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case ADJUST_INVOICE_POS_FAIL:
      return {
        ...state,
        adjustInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_ADJUST_INVOICE_POS:
      return {
        ...state,
        adjustInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // PREVIEW_PDF
    case PREVIEW_PDF_INVOICE_POS:
      return {
        ...state,
        previewPdfFile: {
          data: null,
          loading: true,
          error: null,
        },
      };
    case PREVIEW_PDF_INVOICE_POS_SUCCESS:
      return {
        ...state,
        previewPdfFile: {
          data: action.data,
          loading: false,
          error: null,
        },
      };
    case PREVIEW_PDF_INVOICE_POS_FAIL:
      return {
        ...state,
        previewPdfFile: {
          data: null,
          loading: false,
          error: action.error,
        },
      };
    case RESET_PREVIEW_PDF_INVOICE_POS:
      return {
        ...state,
        previewPdfFile: {
          data: null,
          loading: false,
          error: null,
        },
      };
    // Hủy hóa đơn
    case DELETE_INVOICE_POS:
      return {
        ...state,
        deleteInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case DELETE_INVOICE_POS_SUCCESS:
      return {
        ...state,
        deleteInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case DELETE_INVOICE_POS_FAIL:
      return {
        ...state,
        deleteInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_DELETE_INVOICE_POS:
      return {
        ...state,
        deleteInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Hủy hóa đơn
    case CANCEL_INVOICE_POS:
      return {
        ...state,
        cancelInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CANCEL_INVOICE_POS_SUCCESS:
      return {
        ...state,
        cancelInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case CANCEL_INVOICE_POS_FAIL:
      return {
        ...state,
        cancelInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CANCEL_INVOICE_POS:
      return {
        ...state,
        cancelInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Hủy hóa đơn
    case CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS:
      return {
        ...state,
        callbackTaxRefusedApprovalData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_SUCCESS:
      return {
        ...state,
        callbackTaxRefusedApprovalData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS_FAIL:
      return {
        ...state,
        callbackTaxRefusedApprovalData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS:
      return {
        ...state,
        callbackTaxRefusedApprovalData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Gửi mail hóa đơn
    case SEND_MAIL_INVOICE_POS:
      return {
        ...state,
        sendMailInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case SEND_MAIL_INVOICE_POS_SUCCESS:
      return {
        ...state,
        sendMailInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case SEND_MAIL_INVOICE_POS_FAIL:
      return {
        ...state,
        sendMailInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_SEND_MAIL_INVOICE_POS:
      return {
        ...state,
        sendMailInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // ATTACK_FILE_INVOICE_POS_UPLOAD
    case ATTACK_FILE_INVOICE_POS_UPLOAD:
      return {
        ...state,
        loadingUploadFile: true,
        errorUploadFile: null,
        type: action.type,
      };
    case ATTACK_FILE_INVOICE_POS_UPLOAD_SUCCESS:
      return {
        ...state,
        loadingUploadFile: false,
        errorUploadFile: null,
        uploadFile: {
          id: action.payload.id,
          success: true,
        },
        type: action.type,
      };
    case ATTACK_FILE_INVOICE_POS_UPLOAD_FAIL:
      return {
        ...state,
        loadingUploadFile: false,
        errorUploadFile: {
          error: action.payload.error,
          type: action.payload.type,
        },
        type: action.type,
      };
    case ATTACK_FILE_INVOICE_POS_UPLOAD_RESET:
      return {
        ...state,
        loadingUploadFile: false,
        errorUploadFile: null,
        uploadFile: null,
        type: action.type,
      };

    // GET_INVOICE_POS_REPORT_WORD
    case GET_INVOICE_POS_REPORT_WORD:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadName: null,
      };
    case GET_INVOICE_POS_REPORT_WORD_SUCCESS:
      return {
        ...state,
        type: action.type,
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
      };
    case GET_INVOICE_POS_REPORT_WORD_FAIL:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadName: null,
        error: action.error,
      };
    case RESET_GET_INVOICE_POS_REPORT_WORD:
      return {
        ...state,
        type: action.type,
        error: null,
        fileDownload: null,
        fileDownloadName: null,
      };
    // SUBMIT/APPROVE/REJECT
    case ACTION_WORKFLOW_INVOICE_POS:
      return {
        ...state,
        workflowInvoice: {
          loading: true,
          data: null,
          error: null,
          typeWorkflow: null,
        },
      };
    case ACTION_WORKFLOW_INVOICE_POS_SUCCESS:
      return {
        ...state,
        workflowInvoice: {
          loading: false,
          data: null,
          error: null,
          typeWorkflow: action.typeWorkflow,
        },
        type: action.type,
      };

    case ACTION_WORKFLOW_INVOICE_POS_FAIL:
      return {
        ...state,
        workflowInvoice: {
          loading: false,
          data: null,
          error: action.error,
          typeWorkflow: action.typeWorkflow,
        },
        type: action.type,
      };
    case RESET_ACTION_WORKFLOW_INVOICE_POS:
      return {
        ...state,
        workflowInvoice: {
          loading: false,
          data: null,
          error: null,
          typeWorkflow: null,
        },
        type: action.type,
      };
    // Tạo hóa đơn doanh nghiệp từ hóa đơn khách hàng lẻ
    case CREATE_INVOICE_POS_ENTERPRISE:
      return {
        ...state,
        createInvoiceEnterpriseData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_INVOICE_POS_ENTERPRISE_SUCCESS:
      return {
        ...state,
        createInvoiceEnterpriseData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_INVOICE_POS_ENTERPRISE_FAIL:
      return {
        ...state,
        createInvoiceEnterpriseData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_INVOICE_POS_ENTERPRISE:
      return {
        ...state,
        createInvoiceEnterpriseData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Tạo hóa đơn điều chỉnh giảm 100%
    case CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL:
      return {
        ...state,
        createInvoiceEnterpriseAdjustAllData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_SUCCESS:
      return {
        ...state,
        createInvoiceEnterpriseAdjustAllData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL_FAIL:
      return {
        ...state,
        createInvoiceEnterpriseAdjustAllData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL:
      return {
        ...state,
        createInvoiceEnterpriseAdjustAllData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Upload biên bản đính kèm cho hóa đơn
    case UPLOAD_FILE_INVOICE_POS:
      return {
        ...state,
        uploadFileInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case UPLOAD_FILE_INVOICE_POS_SUCCESS:
      return {
        ...state,
        uploadFileInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case UPLOAD_FILE_INVOICE_POS_FAIL:
      return {
        ...state,
        uploadFileInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case UPLOAD_FILE_INVOICE_POS_RESET:
      return {
        ...state,
        uploadFileInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Xóa biên bản đính kèm cho hóa đơn
    case REMOVE_FILE_INVOICE_POS:
      return {
        ...state,
        removeFileInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case REMOVE_FILE_INVOICE_POS_SUCCESS:
      return {
        ...state,
        removeFileInvoiceData: {
          loading: false,
          data: action.id,
          error: null,
        },
        type: action.type,
      };

    case REMOVE_FILE_INVOICE_POS_FAIL:
      return {
        ...state,
        removeFileInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case REMOVE_FILE_INVOICE_POS_RESET:
      return {
        ...state,
        removeFileInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Xuất danh sách hóa đơn
    case EXPORT_INVOICE_POS:
      return {
        ...state,
        exportInvoiceData: {
          loading: true,
          data: null,
          error: null,
          reportId: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case EXPORT_INVOICE_POS_SUCCESS:
      return {
        ...state,
        exportInvoiceData: {
          loading: false,
          data: null,
          error: null,
          reportId: action.reportId,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case EXPORT_INVOICE_POS_FAIL:
      return {
        ...state,
        exportInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
          reportId: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case EXPORT_INVOICE_POS_RESET:
      return {
        ...state,
        exportInvoiceData: {
          loading: false,
          data: null,
          error: null,
          reportId: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    // Xuất danh sách tem phiếu
    case EXPORT_INVOICE_POS_TICKET:
      return {
        ...state,
        exportInvoiceTicketData: {
          loading: true,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case EXPORT_INVOICE_POS_TICKET_SUCCESS:
      return {
        ...state,
        exportInvoiceTicketData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case EXPORT_INVOICE_POS_TICKET_FAIL:
      return {
        ...state,
        exportInvoiceTicketData: {
          loading: false,
          data: null,
          error: action.error,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case EXPORT_INVOICE_POS_TICKET_RESET:
      return {
        ...state,
        exportInvoiceTicketData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    // Xuất phiếu xuất kho kiêm vận chuyển nội bộ
    case EXPORT_INVOICE_POS_WAREHOUSES:
      return {
        ...state,
        exportInvoiceWarehousesData: {
          loading: true,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case EXPORT_INVOICE_POS_WAREHOUSES_SUCCESS:
      return {
        ...state,
        exportInvoiceWarehousesData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case EXPORT_INVOICE_POS_WAREHOUSES_FAIL:
      return {
        ...state,
        exportInvoiceWarehousesData: {
          loading: false,
          data: null,
          error: action.error,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case EXPORT_INVOICE_POS_WAREHOUSES_RESET:
      return {
        ...state,
        exportInvoiceWarehousesData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    // Xuất phiếu xuất kho kiêm vận chuyển nội bộ
    case EXPORT_INVOICE_POS_WAREHOUSES_AGENCY:
      return {
        ...state,
        exportInvoiceWarehousesAgencyData: {
          loading: true,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_SUCCESS:
      return {
        ...state,
        exportInvoiceWarehousesAgencyData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_FAIL:
      return {
        ...state,
        exportInvoiceWarehousesAgencyData: {
          loading: false,
          data: null,
          error: action.error,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case EXPORT_INVOICE_POS_WAREHOUSES_AGENCY_RESET:
      return {
        ...state,
        exportInvoiceWarehousesAgencyData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };

    // Danh sách lô hóa đơn
    case INVOICE_POS_CAMPAIGN_LIST:
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
          loading: true,
          //   params: action.params,
        },
      };
    case INVOICE_POS_CAMPAIGN_LIST_SUCCESS:
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case INVOICE_POS_CAMPAIGN_LIST_FAIL:
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case INVOICE_POS_CAMPAIGN_LIST_RESET:
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    case SET_COLUMN_VISIBLE_INVOICE_POS_CAMPAIGN_LIST:
      curInvoiceCampaignListData.columnsVisible[action.field] = action.value;
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
        },
      };

    // Upload lô hóa đơn
    case UPLOAD_CAMPAIGNS_INVOICE_POS:
      return {
        ...state,
        uploadCampaignsInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case UPLOAD_CAMPAIGNS_INVOICE_POS_SUCCESS:
      return {
        ...state,
        uploadCampaignsInvoiceData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case UPLOAD_CAMPAIGNS_INVOICE_POS_FAIL:
      return {
        ...state,
        uploadCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case UPLOAD_CAMPAIGNS_INVOICE_POS_RESET:
      return {
        ...state,
        uploadCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Phát hành lô hóa đơn
    case RELEASE_CAMPAIGNS_INVOICE_POS:
      return {
        ...state,
        releaseCampaignsInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case RELEASE_CAMPAIGNS_INVOICE_POS_SUCCESS:
      return {
        ...state,
        releaseCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case RELEASE_CAMPAIGNS_INVOICE_POS_FAIL:
      return {
        ...state,
        releaseCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RELEASE_CAMPAIGNS_INVOICE_POS_RESET:
      return {
        ...state,
        releaseCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Detail lô hóa đơn
    case INVOICE_POS_CAMPAIGN_DETAIL:
      return {
        ...state,
        invoiceCampaignDetailData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case INVOICE_POS_CAMPAIGN_DETAIL_SUCCESS:
      return {
        ...state,
        invoiceCampaignDetailData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case INVOICE_POS_CAMPAIGN_DETAIL_FAIL:
      return {
        ...state,
        invoiceCampaignDetailData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case INVOICE_POS_CAMPAIGN_DETAIL_RESET:
      return {
        ...state,
        invoiceCampaignDetailData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Get thông tin child/parent của hóa đơn thay thế/ điều chỉnh
    case GET_DATA_LINK_POS:
      return {
        ...state,
        linkTypeData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DATA_LINK_POS_SUCCESS:
      let root = undefined;
      let child = undefined;
      if (action.isGetChild) {
        child = action.data;
      } else {
        root = action.data;
      }
      return {
        ...state,
        linkTypeData: {
          loading: false,
          data: {
            root,
            child,
          },
          error: null,
        },
        type: action.type,
      };

    case GET_DATA_LINK_POS_FAIL:
      return {
        ...state,
        linkTypeData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case GET_DATA_LINK_POS_RESET:
      return {
        ...state,
        linkTypeData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Get thông tin ngày lập hóa đơn đã phát hành gần nhất
    case GET_INVOICE_POS_MAX_DATE:
      return {
        ...state,
        invoiceMaxDate: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INVOICE_POS_MAX_DATE_SUCCESS:
      return {
        ...state,
        invoiceMaxDate: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case GET_INVOICE_POS_MAX_DATE_FAIL:
      return {
        ...state,
        invoiceMaxDate: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case GET_INVOICE_POS_MAX_DATE_RESET:
      return {
        ...state,
        invoiceMaxDate: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Get thông tin ngày lập hóa đơn lưu tạm xa nhất
    case GET_INVOICE_POS_MIN_DATE:
      return {
        ...state,
        invoiceMaxMinDate: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INVOICE_POS_MIN_DATE_SUCCESS:
      return {
        ...state,
        invoiceMaxMinDate: {
          loading: true,
          data: {
            max: action.data.maxDate,
            min: action.data.minDate,
          },
          error: null,
        },
        type: action.type,
      };

    case GET_INVOICE_POS_MIN_DATE_FAIL:
      return {
        ...state,
        invoiceMaxMinDate: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case GET_INVOICE_POS_MIN_DATE_RESET:
      return {
        ...state,
        invoiceMaxMinDate: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Xuất phiếu xuất kho kiêm vận chuyển nội bộ
    case DOWNLOAD_ZIP_INVOICE_POS:
      return {
        ...state,
        downloadZipInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case DOWNLOAD_ZIP_INVOICE_POS_SUCCESS:
      return {
        ...state,
        downloadZipInvoiceData: {
          loading: false,
          data: action.dataResponse,
          error: null,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case DOWNLOAD_ZIP_INVOICE_POS_FAIL:
      return {
        ...state,
        downloadZipInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case RESET_DOWNLOAD_ZIP_INVOICE_POS:
      return {
        ...state,
        downloadZipInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case BK_DATA_NEW_POS:
      return {
        ...state,
        bkDataNew: action.data,
      };
    case RESET_BK_DATA_NEW_POS:
      return {
        ...state,
        bkDataNew: null,
      };
    // Lấy ngày hiện tại theo giờ hệ thống
    case GET_CURRENT_TIME_POS:
      return {
        ...state,
        currentTime: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_CURRENT_TIME_POS_SUCCESS:
      console.log("🚀 ~ file: reducer.js:1950 ~ invoicePos ~ action:", action);
      return {
        ...state,
        currentTime: {
          loading: true,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case GET_CURRENT_TIME_POS_FAIL:
      return {
        ...state,
        currentTime: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    default:
      return state;
  }
};

export default invoicePos;
